import BitmapBaseValue from 'core/display/context/texts/BitmapBaseValue'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/rolling'

export default class WinTextCurrency extends BitmapBaseValue{
  constructor(data) {
    super(data)
    this.tween = { value: 0 }
    this.scale.x = this.scale.y = data.scale || 1

    signal.on('WIN-COLLECT', this.animate.bind(this))
    signal.on('CASCADE-WIN-UPDATE-COUNTER', this.animate.bind(this))
    signal.on('WIN-COLLECT-GAMBLE:WIN', this.animateGambleWin.bind(this))
    signal.on('WIN-COLLECT-GAMBLE:LOSE', this.animateResetGamble.bind(this))
    signal.on('ACTION:REQUEST-SPIN', this.reset.bind(this))
    signal.on('STATE:OUT:FS-START', this.reset.bind(this))
    signal.on('RECOVERY:RE-SPIN-LAST-WIN', this.animateRecovery.bind(this))

    this.reset()
  }

  onUpdate() {
    const sing = !this.isBitmap
    const value = FormatService.currency(this.tween.value, sing )
    this.update(value)
  }

  reset() {
    gsap.killTweensOf(this.tween)
    this.tween.value = 0
    this.onUpdate()
  }

  animate({ type, amount }) {
    const value = this.tween.value + amount
    const winTween = gsap.to(this.tween, time[type], {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        winTween.kill()
      },
    })
  }

  animateGambleWin({ amount }) {
    gsap.killTweensOf(this.tween)
    this.tween.value = amount
    this.onUpdate()
  }

  animateResetGamble() {
    gsap.killTweensOf(this.tween)
    this.tween.value = 0
    this.onUpdate()
  }

  animateRecovery({ type, amount }) {
    this.visible = true
    const value = this.tween.value + amount
    const winTween = gsap.to(this.tween, time[type], {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        winTween.kill()
      },
    })
  }

  animateUpdate({ type, amount }) {

    const value = amount
    const winTween = gsap.to(this.tween, time[type], {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        winTween.kill()
      },
    })
  }
}
